/**
 * Custom fetch wrapper that uses the $api plugin with auth headers
 *
 * For declarative/reactive API calls (data fetching on mount)
 *
 * @example
 * // Declarative/reactive data fetching
 * const { data, error } = await useAcvFetch('/api/transport-requests/staged')
 *
 * @example
 * // For imperative calls, destructure $api from useNuxtApp
 * const { $api } = useNuxtApp()
 * const data = await $api('/api/transport-requests/stageJob', {
 *   method: 'POST',
 *   body: payload
 * })
 */
export const useAcvFetch = (url, options) => {
  return useFetch(url, {
    ...options,
    $fetch: useNuxtApp().$api,
  });
};
